import styled from 'styled-components';
export const Center = styled.div `
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 8;
`;
Center.displayName = 'Center';
//# sourceMappingURL=index.js.map